import {combineReducers} from 'redux';

import billingAddressReducer from './billingAddressReducer';

import deliveryAddressListReducer, {selectDeliveryAddress as fromSelectDeliveryAddress} from './deliveryAddressListReducer';
import genericBillingAddressReducer from './genericBillingAddressReducer';
import postcodeAnywhereReducer from './postcodeAnywhereReducer';
import useDeliveryAddressForBillingReducer from './useDeliveryAddressForBillingReducer';

const addressReducer = combineReducers({
  isUseDeliveryAddressForBilling: useDeliveryAddressForBillingReducer,
  deliveryAddressList: deliveryAddressListReducer,
  billingAddress: billingAddressReducer,
  postcodeAnywhere: postcodeAnywhereReducer,
  genericBillingAddress: genericBillingAddressReducer,
});

export const selectDeliveryAddress = state => (
  fromSelectDeliveryAddress(state.deliveryAddressList)
);

export default addressReducer;
